import { render, staticRenderFns } from "./AppCol.vue?vue&type=template&id=0779f59a&scoped=true&"
import script from "./AppCol.vue?vue&type=script&lang=js&"
export * from "./AppCol.vue?vue&type=script&lang=js&"
import style0 from "./AppCol.vue?vue&type=style&index=0&id=0779f59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0779f59a",
  null
  
)

export default component.exports